export const SET_CUSTOMER_NAME="home/SET_CUSTOMER_NAME";
export const SET_CUSTOMER_NAME_SAGA="home/SET_CUSTOMER_NAME_SAGA"
export const GLOBAL_REFRESH = 'GLOBAL_REFRESH';

export const setCustomerName=(customerName)=>{
    return {
        type:SET_CUSTOMER_NAME,
        payload:customerName
    }
}
export const globalRefresh=()=>{
    return {
        type:GLOBAL_REFRESH
    }
}
